(function (win) {
	//-[Date prototypes ]-------------------------------------------------------------------------------------------------------------------

	win.dateFormat = function () {
		var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
			timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
			timezoneClip = /[^-+\dA-Z]/g,
			pad = function (val, len) {
				val = String(val);
				len = len || 2;
				while (val.length < len) val = "0" + val;
				return val;
			};

		// Regexes and supporting functions are cached through closure
		return function (date, mask, utc) {
			var dF = dateFormat;

			// You can't provide utc if you skip other args (use the "UTC:" mask prefix)
			if (arguments.length == 1 && Object.prototype.toString.call(date) == "[object String]" && !/\d/.test(date)) {
				mask = date;
				date = undefined;
			}

			// Passing date through Date applies Date.parse, if necessary
			date = date ? new Date(date) : new Date;
			if (isNaN(date)) {
				if (window['throw']) {
					throw SyntaxError("invalid date");
				} else {
					return '';
				}
			}

			mask = String(dF.masks[mask] || mask || dF.masks["default"]);

			// Allow setting the utc argument via the mask
			if (mask.slice(0, 4) == "UTC:") {
				mask = mask.slice(4);
				utc = true;
			}

			var _ = utc ? "getUTC" : "get",
				d = date[_ + "Date"](),
				D = date[_ + "Day"](),
				m = date[_ + "Month"](),
				y = date[_ + "FullYear"](),
				H = date[_ + "Hours"](),
				M = date[_ + "Minutes"](),
				s = date[_ + "Seconds"](),
				L = date[_ + "Milliseconds"](),
				o = utc ? 0 : date.getTimezoneOffset(),
				flags = {
					d: d,
					dd: pad(d),
					ddd: dF.i18n.dayNames[D],
					dddd: dF.i18n.dayNames[D + 7],
					m: m + 1,
					mm: pad(m + 1),
					mmm: dF.i18n.monthNames[m],
					mmmm: dF.i18n.monthNames[m + 12],
					yy: String(y).slice(2),
					yyyy: y,
					h: H % 12 || 12,
					hh: pad(H % 12 || 12),
					H: H,
					HH: pad(H),
					M: M,
					MM: pad(M),
					s: s,
					ss: pad(s),
					l: pad(L, 3),
					L: pad(L > 99 ? Math.round(L / 10) : L),
					t: H < 12 ? "a" : "p",
					tt: H < 12 ? "am" : "pm",
					T: H < 12 ? "A" : "P",
					TT: H < 12 ? "AM" : "PM",
					Z: utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
					o: (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
					S: ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
				};

			return mask.replace(token, function ($0) {
				return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
			});
		};
	}();
	win.dateFormat.masks = {
		"default": "ddd mmm dd yyyy HH:MM:ss",
		shortDate: "m/d/yy",
		mediumDate: "mmm d, yyyy",
		longDate: "mmmm d, yyyy",
		fullDate: "dddd, mmmm d, yyyy",
		shortTime: "h:MM TT",
		mediumTime: "h:MM:ss TT",
		longTime: "h:MM:ss TT Z",
		isoDate: "yyyy-mm-dd",
		isoTime: "HH:MM:ss",
		isoDateTime: "yyyy-mm-dd'T'HH:MM:ss",
		isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'",
		ozDateTime: "dd/mm/yy hh:MM TT",
		ozDateTimeShort: "dd/mm/yy",
		ozDateTimeFull: "dddd, mmmm d, yyyy hh:MM TT",
		biDateTimeFull: "h:MMtt dddd d mmmm"
	};
	win.dateFormat.i18n = {
		dayNames: [
			"Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",
			"Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
		],
		monthNames: [
			"Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
			"January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
		]
	};

	win.Date.prototype.format = function (mask, utc) {
		return dateFormat(this, mask, utc);
	};
	win.Date.prototype.parseFromOzDate = function (value) {
		var splited = value.split(" ");
		var dd = splited[0].substring(0, 2);
		var mm = splited[0].substring(3, 5);
		var yyyy = splited[0].length > 8 ? splited[0].substring(6, 10) : '20' + splited[0].substring(6, 8);
		var date = mm + '/' + dd + '/' + yyyy
		if (splited.length > 1) {
			date = date + ' ' + splited[1] + ' ' + splited[2];
		}
		return new Date(date);
	};
	win.Date.prototype.ticks = function (date) {
		this.day = date.getDate();
		this.month = date.getMonth() + 1;
		this.year = date.getFullYear();
		this.hour = date.getHours();
		this.minute = date.getMinutes();
		this.second = date.getSeconds();
		this.ms = date.getMilliseconds();

		this.monthToDays = function (year, month) {
			var add = 0;
			var result = 0;
			if ((year % 4 == 0) && ((year % 100 != 0) || ((year % 100 == 0) && (year % 400 == 0)))) add++;

			switch (month) {
				case 0:
					return 0;
				case 1:
					result = 31;
					break;
				case 2:
					result = 59;
					break;
				case 3:
					result = 90;
					break;
				case 4:
					result = 120;
					break;
				case 5:
					result = 151;
					break;
				case 6:
					result = 181;
					break;
				case 7:
					result = 212;
					break;
				case 8:
					result = 243;
					break;
				case 9:
					result = 273;
					break;
				case 10:
					result = 304;
					break;
				case 11:
					result = 334;
					break;
				case 12:
					result = 365;
					break;
			}
			if (month > 1) result += add;
			return result;
		}

		this.dateToTicks = function (year, month, day) {
			var a = parseInt((year - 1) * 365);
			var b = parseInt((year - 1) / 4);
			var c = parseInt((year - 1) / 100);
			var d = parseInt((a + b) - c);
			var e = parseInt((year - 1) / 400);
			var f = parseInt(d + e);
			var monthDays = this.monthToDays(year, month - 1);
			var g = parseInt((f + monthDays) + day);
			var h = parseInt(g - 1);
			return h * 864000000000;
		}

		this.timeToTicks = function (hour, minute, second) {
			return (((hour * 3600) + minute * 60) + second) * 10000000;
		}

		return this.dateToTicks(this.year, this.month, this.day) + this.timeToTicks(this.hour, this.minute, this.second) + (this.ms * 10000);
	};
	win.Date.prototype.toUtc = function () {
		return new Date(this.getUTCFullYear(), this.getUTCMonth(), this.getUTCDate(), this.getUTCHours(), this.getUTCMinutes(), this.getUTCSeconds());
	};
	win.Date.prototype.addHours = function (h) {
		this.setTime(this.getTime() + (h * 60 * 60 * 1000));
		return this;
	};
	win.Date.prototype.timeSpan = function (date) {
		var ticks = this - date,
			day = 86400000,
			hour = 3600000,
			minute = 60000,
			second = 1000,
			index = 1,
			fullTime = {};
		if (ticks < 0) {
			ticks = date - this;
			index = -1;
		}
		fullTime.days = ticks / day;
		fullTime.hours = ticks / hour;
		fullTime.minutes = ticks / minute;
		fullTime.seconds = ticks / second;

		var days = Math.floor(fullTime.days),
			hours = Math.floor(fullTime.hours - days * 24),
			minutes = Math.floor(fullTime.minutes - days * 1440 - hours * 60),
			seconds = Math.floor(fullTime.seconds - days * 86400 - hours * 3600 - minutes * 60);

		return {
			full: fullTime,
			days: days,
			hours: hours,
			minutes: minutes,
			seconds: seconds,
			index: index
		};
	};

	win.onDayOfWeek = function (date) {
		var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
		return (window.GetPageTemplate || kos.getPageTemplate)('_' + days[date.getDay()]);
	};
})(window);